import { Link } from "react-router-dom";

import { config } from "../config";
import "./NotFoundPage.css";

export default function NotFoundPage() {
  return (
    <main className="not-found">
      <div className="not-found-inner">
        <div className="not-found-code">404</div>
        <h1>Page not found</h1>
        <p>We couldn&rsquo;t find that page.</p>
        <Link className="btn btn-primary btn-large" to="/">
          Back to {config.brandName}
        </Link>
      </div>
    </main>
  );
}
